
<div class="document-scanner-container">
  <!-- Mobile scroll hint -->
  <div *ngIf="showScrollHint && isMobile" class="scroll-hint">
    <mat-icon>keyboard_arrow_down</mat-icon>
    <span>Scroll down</span>
  </div>
  
  <div class="scanner-header">
    <h2>{{ 'SCANNER.TITLE' | translate }}</h2>
  </div>
  
  <div class="scanner-content">
    <!-- Camera view (when active) -->
    <div *ngIf="showWebcam" class="camera-container">
      <div class="webcam-wrapper" [class.portrait]="isPortraitOrientation" [class.landscape]="!isPortraitOrientation">
        <webcam #webcam
          [height]="isMobile ? '100%' : 480"
          [width]="isMobile ? '100%' : 640"
          [videoOptions]="videoOptions"
          [allowCameraSwitch]="false"
          [deviceId]="deviceId" 
          [imageQuality]="1"
          (initError)="handleInitError($event)"
          [trigger]="triggerObservable"
          (imageCapture)="handleImage($event)"
        ></webcam>

        <!-- Opaque placeholder shown until the camera stream is actually
             playing. Hides the WebView's native video play-button overlay that
             appears over a source-less/paused <video> (during the permission
             prompt and when permission is denied). -->
        <div *ngIf="!cameraActive" class="camera-placeholder" aria-hidden="true">
          <mat-icon>photo_camera</mat-icon>
          <mat-spinner *ngIf="errors.length === 0" [diameter]="36"></mat-spinner>
        </div>
        
        <!-- Mobile camera switch button -->
        <button
          *ngIf="multipleWebcamsAvailable && isMobile"
          mat-mini-fab
          class="mobile-camera-switch-btn"
          (click)="switchCamera()"
          aria-label="Switch camera"
        >
          <mat-icon>flip_camera_android</mat-icon>
        </button>
      </div>

      <div class="action-buttons">
        <button
          mat-raised-button
          color="primary"
          (click)="triggerSnapshot()"
          [disabled]="isCapturing"
        >
          <mat-icon>photo_camera</mat-icon>
          {{ 'SCANNER.CAPTURE' | translate }}
        </button>
        <button
          *ngIf="multipleWebcamsAvailable && !isMobile"
          mat-stroked-button
          class="desktop-camera-switch-btn"
          (click)="switchCamera()"
        >
          <mat-icon>flip_camera_android</mat-icon>
          {{ 'SCANNER.SWITCH_CAMERA' | translate }}
        </button>
      </div>
    </div>

    <!-- Error message -->
    <div *ngIf="errors.length > 0" class="error-message">
      <mat-icon color="warn">error</mat-icon>
      <p *ngIf="errors[0]?.mediaStreamError?.name === 'NotAllowedError'">
        {{ 'SCANNER.CAMERA_PERMISSION_DENIED' | translate }}
      </p>
      <p *ngIf="errors[0]?.mediaStreamError?.name === 'NotFoundError'">
        No camera found. Please make sure your device has a camera.
      </p>
      <p *ngIf="errors[0]?.mediaStreamError?.name === 'NotReadableError' || errors[0]?.mediaStreamError?.name === 'AbortError'">
        Camera is in use by another application or not accessible.
      </p>
      <p *ngIf="!errors[0]?.mediaStreamError || (errors[0]?.mediaStreamError?.name !== 'NotAllowedError' && 
                errors[0]?.mediaStreamError?.name !== 'NotFoundError' && 
                errors[0]?.mediaStreamError?.name !== 'NotReadableError' && 
                errors[0]?.mediaStreamError?.name !== 'AbortError')">
        {{ 'SCANNER.CAMERA_ERROR' | translate }}
      </p>
      <button mat-stroked-button (click)="setupCameras()" class="retry-btn">
        <mat-icon>refresh</mat-icon> Retry
      </button>
    </div>

    <!-- Thumbnails of captured images -->
    <div class="captured-images" *ngIf="capturedImages.length > 0">
      <h3>{{ 'SCANNER.CAPTURED_PAGES' | translate }} ({{ capturedImages.length }})</h3>
      <div class="thumbnail-grid" [class.mobile-grid]="isMobile">
        <div
          *ngFor="let capturedImage of capturedImages; let i = index"
          class="thumbnail-item"
        >
          <div class="thumbnail">
            <img [src]="capturedImage.imageAsDataUrl" alt="Captured Page" />
            <div class="page-number">{{ i + 1 }}</div>
            <button
              mat-icon-button
              color="warn"
              class="delete-btn"
              (click)="removeImage(i)"
              matTooltip="{{ 'SCANNER.REMOVE_IMAGE' | translate }}"
            >
              <mat-icon>delete</mat-icon>
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Filename input for the PDF -->    <div class="filename-container" *ngIf="capturedImages.length > 0">
      <mat-form-field appearance="outline" class="filename-field">
        <mat-label>{{ 'SCANNER.FILENAME' | translate }}</mat-label>
        <input
          matInput
          type="text"
          [(ngModel)]="fileName"
          placeholder="{{ 'SCANNER.FILENAME_PLACEHOLDER' | translate }}"
          #fileNameInput
          autocomplete="off"
          autocorrect="off"
        />
        <mat-hint>{{ 'SCANNER.FILENAME_HINT' | translate }}</mat-hint>
      </mat-form-field>
    </div>
    
    <!-- Action buttons - moved from footer -->
    <div class="action-bar">
      <button
        mat-stroked-button
        (click)="cancelScanning()"
        class="cancel-btn"
      >
        <mat-icon>close</mat-icon>
        {{ 'SCANNER.CANCEL' | translate }}
      </button>

      <button
        mat-raised-button
        color="primary"
        [disabled]="capturedImages.length === 0"
        (click)="completeScanning()"
        class="complete-btn"
      >
        <mat-icon>check</mat-icon>
        {{ 'SCANNER.COMPLETE' | translate }}
      </button>
    </div>
  </div>
</div>
